import script from "./GanttChart.vue?vue&type=script&setup=true&lang=js"
export * from "./GanttChart.vue?vue&type=script&setup=true&lang=js"

import "./GanttChart.vue?vue&type=style&index=0&id=8c7e6590&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c7e6590"]])

export default __exports__